import React, { useContext, useEffect } from 'react'
import { useBillingContext, usePhoenixSessionContext } from 'providers'
import Cachier from 'cachier'
const sessionStorageKey = 'user-is-redirected'
import { getPhoneCom } from 'phonecom'
import { NavigationContext } from 'navigation'
import { useHistory } from 'react-router-dom'

/**
 *
 */
const RedirectingValidator = (): JSX.Element => {
    const { goToNavItem } = useContext(NavigationContext)
    const history = useHistory()
    const { session } = usePhoenixSessionContext()
    const { getData, paymentMethodsPrimary, invoiceDetails } = useBillingContext()

    const billingDataIsValid = (): boolean => {
        if (invoiceDetails && invoiceDetails.cb_is_past_due) {
            return false
        }

        if (paymentMethodsPrimary) {
            const expMonth = paymentMethodsPrimary.details.exp_month
            const expYear = paymentMethodsPrimary.details.exp_year
            const now = new Date()
            const currentYear = now.getFullYear()
            const currentMonth = now.getMonth() + 1
            if (
                currentYear >= expYear ||
                (
                    currentYear === expYear &&
                    currentMonth > expMonth
                )
            ) {
                return false
            }
        }

        return true
    }

    const checkBillingStatus = async () => {
        // if (cachier.getItem(sessionStorageKey)) return null
        const { pathname } = window.location
        if (pathname && pathname.includes('/bill-and-pay')) {
            return null
        }

        const phoneCom = await getPhoneCom()
        const isAdmin = phoneCom?.role === 'account'
        if (!isAdmin) return null

        return billingDataIsValid()
    }

    const loadData = async () => {
        if (session && session.user) await getData()
    }

    useEffect(() => {
        loadData()
    }, [session.user])

    useEffect(() => {
        checkBillingStatus().then((userBillingDataIsValid) => {
            const cachier = new Cachier(session.user.id)
            if (userBillingDataIsValid === false) {
                cachier.setItem(sessionStorageKey, true)
                goToNavItem('billing')
            } else if (!cachier.getItem(sessionStorageKey)) {
                const targetPathKey = 'targetPath'
                const urlBeforeLogin = sessionStorage.getItem(targetPathKey)
                if (urlBeforeLogin) {
                    history.push(urlBeforeLogin)
                    sessionStorage.removeItem(targetPathKey)
                }
            }
        })
    }, [invoiceDetails, paymentMethodsPrimary])

    return <></>
}

export default RedirectingValidator
